import {
  provideMissingTranslationHandler,
  provideTranslateLoader,
  provideTranslateService
} from '@ngx-translate/core';
import { EmptyTranslationFallbackLoader } from './empty-translation-fallback.loader';
import { EnglishDefaultMissingTranslationHandler } from './english-default-missing-translation.handler';

export function provideI18n() {
  return [
    provideTranslateService({
      lang: 'en',
      fallbackLang: 'en',
      loader: provideTranslateLoader(EmptyTranslationFallbackLoader),
      missingTranslationHandler: provideMissingTranslationHandler(
        EnglishDefaultMissingTranslationHandler
      ),
    }),
  ];
}
